<template>
  <template v-for="(section, sectionIndex) in sections" :key="getSectionKey(section, sectionIndex)">
    <component
      v-if="section?.enabled && sectionComponentMap[section?.__component]"
      :is="sectionComponentMap[section.__component]"
      :component="section.__component"
      :data="section"
      :animate="animate"
      v-bind="extraProps"
    />
  </template>
</template>

<script setup>
import { defineAsyncComponent } from "vue";

const props = defineProps({
  sections: { type: Array, default: () => [] },
  animate: { type: [Boolean, Object], default: undefined },
  extraProps: { type: Object, default: () => ({}) },
});

const getSectionKey = (section, index) => {
  return `${section?.__component || "section"}-${section?.id || index}`;
};

// Map of Strapi component names to Vue components (relative paths from this file)
const sectionComponentMap = {
  "sections.accordion": defineAsyncComponent(() => import("./Accordion/Accordion.vue")),
  "sections.image-accordion": defineAsyncComponent(() => import("./ImageAccordion/ImageAccordion.vue")),
  "sections.banner-boxed": defineAsyncComponent(() => import("./Banner/Boxed.vue")),
  "sections.blog-list": defineAsyncComponent(() => import("./BlogList/BlogList.vue")),
  "sections.brands": defineAsyncComponent(() => import("./Brands/Brands.vue")),
  "sections.card-brands": defineAsyncComponent(() => import("./Card/Brands.vue")),
  "sections.card-news": defineAsyncComponent(() => import("./Card/News.vue")),
  "sections.card-certificates": defineAsyncComponent(() => import("./Card/Certificates.vue")),
  "sections.card-default": defineAsyncComponent(() => import("./Card/Default.vue")),
  "sections.card-gallery": defineAsyncComponent(() => import("./Card/Gallery.vue")),
  "sections.card-icon": defineAsyncComponent(() => import("./Card/Icon.vue")),
  "sections.card-image": defineAsyncComponent(() => import("./Card/Image.vue")),
  "sections.blog-post": defineAsyncComponent(() => import("./Card/Image.vue")),
  "sections.card-text": defineAsyncComponent(() => import("./Card/Text.vue")),
  "sections.card-video": defineAsyncComponent(() => import("./Card/Video.vue")),
  "sections.gallery": defineAsyncComponent(() => import("./Gallery/Gallery.vue")),
  "sections.overview": defineAsyncComponent(() => import("./RichText/RichText.vue")),
  "sections.about": defineAsyncComponent(() => import("./About/About.vue")),
  "sections.service-list": defineAsyncComponent(() => import("./ServiceList/ServiceList.vue")),
  "sections.news-list": defineAsyncComponent(() => import("./NewsList/NewsList.vue")),
  "sections.story": defineAsyncComponent(() => import("./Story/Story.vue")),
  "sections.story-background": defineAsyncComponent(() => import("./Story/Background.vue")),
  "sections.tab": defineAsyncComponent(() => import("./Tab/Tab.vue")),
  "sections.tab-link": defineAsyncComponent(() => import("./Tab/Link.vue")),
  "sections.testimonials": defineAsyncComponent(() => import("./Testimonials/Testimonials.vue")),
  "sections.video": defineAsyncComponent(() => import("./Video/Video.vue")),
  "sections.image-compare": defineAsyncComponent(() => import("./ImageCompare/ImageCompare.vue")),
  "sections.team-member": defineAsyncComponent(() => import("./Card/Team.vue")),
  "sections.stats": defineAsyncComponent(() => import("./Stats/Stats.vue")),
  "sections.instagram": defineAsyncComponent(() => import("./Instagram/Instagram.vue")),
  "sections.map": defineAsyncComponent(() => import("./Map/Map.vue")),
  "sections.download": defineAsyncComponent(() => import("./Download/Download.vue")),
};
</script>
